var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRefinedCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "currentColor",
  rx: 16
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "currentColor",
  transform: "translate(8 8)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m22.88 12.792-3.187-.406-.404-3.304-2.004 2.628-3.048-1.244 1.27 3.03-2.766 1.985 1.824.22-5.932 5.898 1.766 1.766 5.96-5.927.255 1.842 1.93-2.753 3.029 1.251-1.209-3.036zM10.4 22.235l-.634-.634 5.812-5.778.566.068.077.557zm7.856-6.692-1.128 1.612-.276-1.985-1.973-.237 1.614-1.158-.771-1.838 1.83.746 1.182-1.552.242 1.97 1.889.242-1.466 1.136.732 1.84zm-3.759-2.731-1.6-.4-.194.776 1.6.4zm2.691-2.509-.4-1.6-.776.194.4 1.6zm5.095-.02-.565-.564-1.2 1.2.566.564zm-.586 4.53-.194.775 1.6.399.194-.776zm-3.285 2.884.4 1.6.776-.194-.4-1.6z"
})));
export default SvgRefinedCircle;